import { Box, FormControlLabel, Switch } from '@mui/material';
import { t } from 'i18next';
import { ChangeEvent } from 'react';

type CallbackFn = (value: boolean) => void;

type Props = {
  isRecommendedFilterEnabled: boolean;
  isNegotiationFilterEnabled: boolean;
  onRecommendedFilterChange: CallbackFn;
  onNegotiationFilterChange: CallbackFn;
  isToggleDisabled: boolean;
};

export const ReportCiphersuitesHeader = (props: Props) => {
  const { isNegotiationFilterEnabled, onNegotiationFilterChange, onRecommendedFilterChange, isRecommendedFilterEnabled, isToggleDisabled } = props;

  const onFilterChange = (callback: CallbackFn) => (_event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    callback(checked);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
      <FormControlLabel
        disabled={isToggleDisabled}
        control={<Switch onChange={onFilterChange(onNegotiationFilterChange)} checked={isNegotiationFilterEnabled} />}
        label={t('ciphersuites.onlySelectedNegotiation')}
      />
      <FormControlLabel
        disabled={isToggleDisabled}
        control={<Switch onChange={onFilterChange(onRecommendedFilterChange)} checked={isRecommendedFilterEnabled} />}
        label={t('ciphersuites.onlyRecommended')}
      />
    </Box>
  );
};
